export const getDiffPricing = terms => {
  let iterationId = null;
  let granuleGuid = null;

  terms.find(term => {
    return term.publishOptions?.periods?.find(period => {
      const { diffPriceIterationId, diffPriceGranuleGuid } = period.tariffIdentificator || {};

      if (!!diffPriceIterationId || !!diffPriceGranuleGuid) {
        iterationId = diffPriceIterationId;
        granuleGuid = diffPriceGranuleGuid;

        return true;
      }

      return false;
    });
  });

  return { iterationId, granuleGuid };
};
